<template>
  <div v-if="cert_data != null">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <template>
      <div v-if="show == true" ref="document" id="document1" class="printdiv">

        <div v-if="org_basic_data.school_name == 'Zeal International School'">
          <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt="" width="100%" />
        </div>
        <div style="border: 2px solid black; margin: 6px;" v-else>
          <v-row>
            <v-col cols="12" sm="3" md="3" align="center">
              <img :src="org_basic_data.trust_logo" alt="" class="school-logo" /><br>
              <b> UDISE No: {{ cert_data.udise_no }} </b>
            </v-col>
            <v-col cols="12" sm="9" md="9" align="center">
                <h3 class="trust-name">{{ org_basic_data.trust_name }}</h3>
                <h1 class="trust-name">{{ org_basic_data.school_name }}</h1>
                <h3 class="trust-name">(English Medium)</h3>
                <p style="margin: 0;">{{ org_basic_data.address }}</p>
                <p style="margin: 0;"> Ph.No. {{ org_basic_data.phone }}  Email: {{ org_basic_data.email }}</p>
                <p style="margin: 0;" v-html="org_basic_data.line1"></p>
                <p style="margin: 0;" v-html="org_basic_data.line2"></p>
            </v-col>
          </v-row>
          <div style="text-align: center;">
            <h3 class="section-name">{{ cert_data.section_name }}</h3>
          </div>
        </div>
        <!-- <div class=" row header" v-else>
          <v-col cols="12" sm="3" md="3" class="pb-0" style="max-height: min-content;">
              <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
              <span class="b-sapn h2-span" style="font-weight: 500; margin-left: 18px; font-size: 15px">
                <b> UDISE No: {{ cert_data.udise_no }} </b>
              </span>
            </v-col>
            <v-col cols="12" sm="9" md="9" class="pb-0" style="max-height: min-content;">
              <center>
                <h3 class="trust-name">{{ org_basic_data.trust_name }}</h3>
                <h1 class="schl-name">{{ org_basic_data.school_name }}</h1>
                <h3 style="text-transform: uppercase">(English Medium)</h3>
                <span class="adrs">{{ org_basic_data.address }}</span><br />
                <span class="adrs"> Ph.No. {{ org_basic_data.phone }} </span>
                <span style="margin-left: 5px">
                  Email: {{ org_basic_data.email }} </span><br />
                <span class="line1" v-html="org_basic_data.line1"></span><br />

                <span class="line2" v-html="org_basic_data.line2"></span>
              </center>
            </v-col>
            <div class="section-container">
              <span class="stdsection">{{ cert_data.section_name }}</span>
            </div>
          </div> -->

        <div class="bonacontent">
          <v-row dense>
            <h1 class="bonaheading">Bonafide Certificate</h1>
          </v-row>
          <div class="container middle">
            <span class="h2-span">
              General Register No.
              <span style="font-weight: 600">:-&nbsp;{{ cert_data.gr_no }}</span>
            </span>

            <span class="h2-span" style="margin-left: 60px">
              Academic Year
              <span style="font-weight: 600">:-&nbsp;{{ cert_data.ay }}</span>
            </span>
            <span class="h2-span" style="margin-left: 50px; margin-bottom: 5px">
              Sr. No.
              <span style="font-weight: 600">:-&nbsp;{{ cert_data.cert_no }}</span> </span>
            <br /><span class="b-span h2-span">This is to Certify that,</span>
            <br /><span class="b-span h2-span">The details of Bonafide Student of this School are given
              below.</span>
            <v-row dense>
              <v-col cols="12" md="9" sm="9" class="col-md-9">
                <span class="b-sapn">
                  Student's Full Name
                  <span class="name">:-&nbsp;{{ cert_data.stud_name }}</span> </span>
                <span class="b-sapn">
                  Standard & Division
                  <span class="name">:-&nbsp;{{ cert_data.std }}</span>
                  <span v-if="cert_data.div !== ''">
                    <b> - {{ cert_data.div }} </b></span> </span>
                <span class="b-sapn">
                  D.O.B. (In Figure)
                  <span class="name" style="margin-left: 65px">:-&nbsp;{{ cert_data.dob }}</span> </span>
                <span class="b-sapn">
                  D.O.B. (In Words)
                  <span class="name" style="margin-left: 62px">:-&nbsp;{{ cert_data.dob_words }}</span> </span>
                <span class="b-sapn">
                  Aadhaar (UID)
                  <span class="name" style="margin-left: 91px">:-&nbsp;{{ cert_data.aadhar }}</span> </span>
                <span v-if="org_basic_data.school_name === 'Zeal International School'" class="b-sapn">
                  SARAL ID
                  <span class="name" style="margin-left: 121px">:-&nbsp;{{ cert_data.saral_id }}</span> </span>
                <span v-if="org_basic_data.school_name === 'Zeal International School'" class="b-sapn">
                  PEN
                  <span class="name" style="margin-left: 166px">:-&nbsp;{{ cert_data.pen_no }}</span> </span>
                <span v-if="org_basic_data.school_name === 'Zeal International School'" class="b-sapn">
                  APAAR ID
                  <span class="name" style="margin-left: 120px">:-&nbsp;{{ cert_data.apaar_id }}</span> </span>
                <span class="b-sapn">
                  Nationality
                  <span class="name" style="margin-left: 112px">:-&nbsp;{{ cert_data.nationality }}</span> </span>
                <span class="b-sapn">
                  Place Of Birth
                  <span class="name" style="margin-left: 86px">:-&nbsp;{{ cert_data.place_of_birth }}</span> </span>
                <span class="b-sapn">
                  Religion-Caste
                  <span v-if="org_basic_data.id != 1" class="name" style="margin-left: 90px">:-&nbsp;{{ cert_data.religion }}-{{
                    cert_data.caste
                  }}</span> 
                  <span v-else class="name" style="margin-left: 90px">:-&nbsp;{{ cert_data.religion_lowercase }}-{{
                    cert_data.caste_lowercase
                  }}</span> </span>
                <span class="b-span h2-span">To the best of my knowledge he/she bears a good moral
                  character.</span><br />
                <span class="b-sapn">
                  Date
                  <span class="name">:-&nbsp;{{ cert_data.cert_date }}</span> </span>
                <span class="b-sapn">
                  Place
                  <span class="name" style="margin-left: 37px">:-&nbsp;{{ cert_data.place }}</span> </span>
              </v-col>
              <v-col cols="12" md="3" sm="3" class="photo" v-if="cert_data.photo != null">
                <img :src="awspath + cert_data.photo" alt="photostudent"
                  style="height: 31%; width: 73%; border: 1px solid black;" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col></v-col>
              <v-col cols="12" md="6" sm="6" class="mt-3 ">
                <center>
                  <div v-if="org_basic_data.school_name === 'Zeal International School'"
                    class="h2-span margin-top">Prepared By</div>
                  <div v-else>
                    <span class="h2-span">Principal</span>
                    <div class="h2-span" style="margin-top: -12px;"> {{ org_basic_data.school_name }}</div>
                  </div>
                </center>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <br />
      <v-card class="box no-display">
        <div class="no-display" style="text-align: center">
          ----------------------------------Modify------------------------------------
        </div>
        <br />
        <v-row class="no-display" justify="center">
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Standard" v-model.trim="cert_data.std"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Division" v-model.trim="cert_data.div"></v-text-field>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";

import "@/assets/css/color.css"; 
export default {
  data() {
    return {
      snackbar: false,
      fetch_loader: false,
      gen_cert_loader: false,
      show_cert_loader: false,
      search: "",
      dialog: false,
      awspath: "",
      snackbar_msg: "",
      color: "",
      data_list: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      cert_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      overlay: false,
      show: true,
      org_basic_data: [],
      progress: 0,
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
    print() {
      var content = document.getElementById("document1").outerHTML;
      var mywindow = document.body.innerHTML;
      document.body.innerHTML = content;
      window.print();
      document.body.innerHTML = mywindow;
      location.reload();
      return true;
    },
    close() {
      this.$router.push({ name: "certificate-zeal-bonafied", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.cert_data = JSON.parse(this.$route.query.cert_data || '{}');
      this.org_basic_data = JSON.parse(this.$route.query.org_basic_data || '{}');
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.onload();
  },
};
</script>

<style scoped>
.middle {
  line-height: 300%;
}
.school-logo {
  width: 180px;
  max-width: 90%;
  height: auto;
}
.section-name{
  text-align: center;
  text-transform: uppercase;
}
/* shiv css */
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .b-sapn, .b-span {
    display: block !important;
    margin-top: 2px !important;
    font-size: larger !important;
  }

  .h2-span {
    font-size: larger !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"] {
    display: none !important;
  }

  .photo {
    width: 25% !important; 
    height: auto !important;
  }
  
  .photo img {
    height: 140px !important;
    width: 110px !important;
    object-fit: cover !important;
  }

  .margin-top {
    margin-top: 20px !important;
  }

  @page {
    size: A4 portrait;
    margin: 0.4in !important; 
  }

  .printdiv {
    page-break-inside: avoid !important;
    page-break-after: avoid !important;
    width: 100% !important; 
    margin: 0 auto !important; 
    padding: 15px !important;
    box-sizing: border-box !important;
  }

  /* CHANGED: Tightened from 190% to 175% to bring the bottom border comfortably inside page 1 */
  .middle {
    line-height: 175% !important; 
  }

  /* CHANGED: Dynamic block handling to prevent overflow bounds */
  .header {
    height: auto !important;
    min-height: 200px !important;
    line-height: 135% !important;
    padding-bottom: 5px !important;
  }

  * {
    overflow: hidden !important;
  }

  /* CHANGED: Reduced font-size slightly to fix the school name wrapping overlap */
  .schl-name {
    font-size: 24px !important;
    margin: 4px 0px !important;
    line-height: 1.2 !important;
  }
}

.b-sapn {
  display: block;
  margin-top: 2px;
}

.name {
  margin-left: 44px;
  font-weight: 600;
}

.schlImg {
  width: 87%;
  height: 60%;
  margin-left: 10px;
}

.printdiv {
  border: 3px solid;
  border-color: black;
  width: auto;
  margin-left: 5%;
  margin-right: 5%;
}

.header {
  border: 2px solid;
  margin: 6px;
  height: 300px;
}

.trust-name {
  text-transform: uppercase;
}

.schl-name {
  font-size: 30px;
  text-transform: uppercase;
}

.adrs {
  margin-left: 33px;
}

.line1 {
  margin-left: 15px;
}

.line2 {
  margin-left: 22px;
}

.stdsection {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 20px;
}

.bonaheading {
  border-bottom: 3px solid black;
  margin-left: 32%;
  line-height: 1em;
  margin-top: 1%;
  margin-bottom: 2%;
  text-transform: uppercase;
}
</style>

<style>
@media print {
  html, body {
    height: 100% !important;
    max-height: 100% !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>